import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AuthComponent } from './auth/auth.component';
import { PAuthComponent } from './pauth/pauth.component';
import { SignupComponent } from './signUp/signup.component';
import { ForgotpwdComponent } from './forgotpwd/forgotpwd.component';
import { SharedModule, AuthGuard, User } from './shared';
import { NoAuthGuard } from './auth/no-auth-guard.service';
import { PatientComponent } from './patient/patient.component';
import { FullLayoutComponent } from './layouts/full-layout.component';
import { UnsubscribeComponent } from './unsubscribe/unsubscribe.component';
import { CanDeactivateGuard } from './shared/can-deactivate/can-deactivate.guard';
import { EmailunsubscribeComponent } from './patientonboard/emailunsubscribe/emailunsubscribe.component';
import { CnmappingComponent } from './cnmapping/cnmapping.component';
import { SecurityquestionComponent } from './patientonboard/securityquestion/securityquestion.component'
import { ProfilesecurityquestionComponent } from './hospital/profilesecurityquestion/profilesecurityquestion.component';

import { StykerLoginComponent } from './styker-login/styker-login.component';
import { ClientSetupComponent } from './client-setup/client-setup.component';
import { ManageClientUserComponent } from './manage-client-user/manage-client-user.component';

//Hospital Page
import { AddgiverComponent } from './hospital/addgiver/addgiver.component';
import { AddpartnerComponent } from './hospital/addpartner/addpartner.component';
import { AddpatientComponent } from './hospital/addpatient/addpatient.component';
import { AnybodypartComponent } from './hospital/anybodypart/anybodypart.component';
import { AppointmentsComponent } from './hospital/appointments/appointments.component';
import { AssementComponent } from './hospital/assement/assement.component';
import { PSAssementComponent } from './hospital/passement/passement.component';
import { DashComponent } from './hospital/dash/dash.component';
import { Documentpage1Component } from './hospital/documentpage1/documentpage1.component';
import { HospitalmetricsComponent } from './hospital/hospitalmetrics/hospitalmetrics.component';
import { MessagesComponent } from './hospital/messages/messages.component';
import { MytodoComponent } from './hospital/mytodo/mytodo.component';
import { NewsymptomComponent } from './hospital/newsymptom/newsymptom.component';
import { EditsymptomComponent } from './hospital/editsymptom/editsymptom.component';
import { PdfpageComponent } from './hospital/pdfpage/pdfpage.component';
import { PostoppComponent } from './hospital/postopp/postopp.component';
import { ProfileComponent } from './hospital/profile/profile.component';
import { SnfpatientComponent } from './hospital/snfpatient/snfpatient.component';
import { SurveymetricsComponent } from './hospital/surveymetrics/surveymetrics.component';
import { ViewsummaryComponent } from './hospital/viewsummary/viewsummary.component';
import { PatsummaryComponent } from './hospital/patsummary/patsummary.component';
import { HospitalComponent } from './hospital/hospital.component';
import { PatientdetailsComponent } from './hospital/patientdetails/patientdetails.component';
import { ToolkittComponent } from './hospital/toolkit/toolkit.component';
import { MessagehospComponent } from './hospital/messagehosp/messagehosp.component';
import { QuestionComponent } from './hospital/questions/questions.component';

//Patient Page
import { DocumentComponent } from './patient/document/document.component';
import { ContactmeComponent } from './patient/contactme/contactme.component';
import { ExercisevideosComponent } from './patient/exercisevideos/exercisevideos.component';
import { PainlevelComponent } from './patient/painlevel/painlevel.component';
import { ActivityBoardComponent } from './patient/activityboard/activityboard.component';
import { AddcareComponent } from './patient/addcare/addcare.component';
import { AppointmentComponent } from './patient/appointment/appointment.component';
import { PAssementComponent } from './patient/assement/passement.component';
import { UploadpageComponent } from './patient/uploadpage/uploadpage.component';
import { ProfilequesComponent } from './patient/profileques/profileques.component';
import { HelpdeskpageComponent } from './patient/helpdesk/helpdesk.component';
import { CarefamilyComponent } from './patient/carefamily/carefamily.component';
import { DashboardComponent } from './patient/dashboard/dashboard.component';
import { DashboarddComponent } from './patient/dashboard2/dashboard2.component';
import { MessageComponent } from './patient/messages/messages.component';
import { MyprofileComponent } from './patient/myprofile/myprofile.component';
import { PatsyComponent } from './patient/patsy/patsy.component';
import { PostoperativeComponent } from './patient/postoperative/postoperative.component';
import { PreventinginfectionComponent } from './patient/preventinginfection/preventinginfection.component';
import { ReportComponent } from './patient/report/report.component';
import { SupportComponent } from './patient/support/support.component';
import { ResSupportComponent } from './ressupport/ressupport.component';
import { SurveysComponent } from './patient/surveys/surveys.component';
import { ChangepwdComponent } from './changepwd/changepwd.component';
import { CarepasswordComponent } from './carepassword/carepassword.component';
import { ResetpassComponent } from './resetpass/resetpass.component';
import { OtpComponent } from './otp/otp.component'

//patientonboard
import { PatientonboardComponent } from './patientonboard/patientonboard.component';
import { CreatenewpasswordComponent } from './patientonboard/createnewpassword/createnewpassword.component';
import { CreatecarepasswordComponent } from './patientonboard/createcarepassword/createcarepassword.component';
import { WelcomeComponent } from './patientonboard/welcome/welcome.component';
import { WelcomepageComponent } from './patientonboard/welcomepage/welcomepage.component';
import { WelcomemailComponent } from './patientonboard/welcomemail/welcomemail.component';
import { IntropageComponent } from './patientonboard/Intropage/Intropage.component';
import { ProfilepageComponent } from './patientonboard/profilepage/profilepage.component';
import { UploadComponent } from './patientonboard/upload/upload.component';
import { CarepathreadyComponent } from './patientonboard/carepathready/carepathready.component';
import { HelpdeskComponent } from './patientonboard/helpdesk/helpdesk.component';
import { SupportpageComponent } from './patientonboard/supportpage/supportpage.component';
import { PatienthomeComponent } from './patienthome/patienthome.component';
import { DelpatComponent } from './patienthome/delpat/delpat.component';
import { ToolkitComponent } from './patient/toolkit/toolkit.component';
import { PatientAssessmentDetailsComponent } from './patient/patient-assessment-details/patient-assessment-details.component';
import { AddnewpatientComponent } from './hospital/addnewpatient/addnewpatient.component';
import { SecurityComponent } from './patientonboard/security/security.component';
import { Security1Component } from './patientonboard/security1/security1.component';
import { QuestionsComponent } from './patientonboard/questions/questions.component';
import { Questions1Component } from './patientonboard/questions1/questions1.component';
import { CodeComponent } from './patientonboard/code/code.component';
import { SauthComponent } from './sauth/sauth.component';

//Ipcapture
import { IpcaptureComponent } from './ipcapture/ipcapture.component';
import { RecoverycoachComponent } from './ipcapture/recoverycoach/recoverycoach.component';
import { RecoverypatComponent } from './ipcapture/recoverypat/recoverypat.component';
import { LoginascarenavicatorComponent } from './hospital/loginascarenavicator/loginascarenavicator.component';
import { BrowsernotificationComponent } from './browsernotification/browsernotification.component';
import { PatdashComponent } from './hospital/patdash/patdash.component';
import { PatqualifiComponent } from './hospital/patqualifi/patqualifi.component';
import { LoginfromonboardComponent } from './hospital/loginfromonboard/loginfromonboard.component';
import { LoginasmodeComponent } from './loginasmode/loginasmode.component'
import { AppstoreComponent } from './appstore/appstore.component';
import { Restpass1Component } from './hospital/restpass/restpass.component';
import { UservalidationComponent } from './patientonboard/uservalidation/uservalidation.component';
import { CanSessionDeactivateGuard } from './shared/can-deactivate/can-sessiondeactive.guard';
import { UservalidateforCcComponent } from './patientonboard/uservalidatefor-cc/uservalidatefor-cc.component';
import { DocumentsComponent } from './patient/documents/documents.component';
import { NeedHelpComponent } from './need-help/need-help.component';

const appRoutes: Routes = [
    { path: 'plogin/:name', redirectTo: '/plogin/:name' },
    { path: 'slogin/:name', redirectTo: '/slogin/:name' },
    { path: '', redirectTo: '/login', pathMatch: 'full' },
    { path: 'login', component: AuthComponent, canActivate: [NoAuthGuard] },
    { path: 'notification', component: BrowsernotificationComponent, canActivate: [NoAuthGuard] },
    { path: 'appstore', component: AppstoreComponent, canActivate: [NoAuthGuard] },
    {
        path: '', component: PatientonboardComponent, canActivate: [NoAuthGuard],
        children: [
            {
                path: 'createnewpass',
                component: CreatenewpasswordComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'createcarepass',
                component: CreatecarepasswordComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'carepath',
                component: WelcomeComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'welcome/:id',
                component: WelcomepageComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'welcomemail/:id',
                component: WelcomemailComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'intro/:id',
                component: IntropageComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'uservalidate',
                component: UservalidationComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'uservalidate/:id',
                component: UservalidateforCcComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'profilepage/:id',
                component: ProfilepageComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'upload',
                component: UploadComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'security',
                component: SecurityComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'security1',
                component: Security1Component,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'code/:id',
                component: CodeComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'questions/:id',
                component: QuestionsComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'questions/:id',
                component: QuestionsComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'questions1/:id',
                component: Questions1Component,
                canActivate: [NoAuthGuard]
            },




            {
                path: 'thankyou',
                component: CarepathreadyComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'helpdesk',
                component: HelpdeskComponent,
                canActivate: [NoAuthGuard]
            },
            {
                path: 'supportpage',
                component: SupportpageComponent,
                canActivate: [NoAuthGuard]
            }

        ]
    },
    {
        path: 'security', component: IpcaptureComponent, canActivate: [AuthGuard],
        canDeactivate: [CanSessionDeactivateGuard],
        children: [
            {
                path: 'recovery',
                component: RecoverycoachComponent,
                canActivate: [AuthGuard]
            },
            {
                path: 'recoverypat',
                component: RecoverypatComponent,
                canActivate: [AuthGuard]
            },

            // {
            //         path: 'security',   
            //         component: SecurityComponent,
            //         canActivate: [AuthGuard]
            // },
            {
                path: 'code',
                component: CodeComponent,
                canActivate: [AuthGuard]
            },


        ]
    },
    { path: 'slogin/:tokenId', component: SauthComponent },
    { path: 'plogin/:name', component: PAuthComponent, canActivate: [NoAuthGuard] },
    { path: 'signup/:name', component: SignupComponent, canActivate: [NoAuthGuard] },
    { path: 'need-help', component: NeedHelpComponent, canActivate: [NoAuthGuard] },
    { path: 'unsubcribe/:name', component: UnsubscribeComponent, canActivate: [NoAuthGuard] },
    { path: 'forgotpassword', component: ForgotpwdComponent, canActivate: [NoAuthGuard] },
    { path: 'changepassword/:name', component: ChangepwdComponent, canActivate: [NoAuthGuard] },
    { path: 'changepassword', component: ChangepwdComponent, canActivate: [NoAuthGuard] },
    { path: 'carepassword/:name', component: CarepasswordComponent, canActivate: [NoAuthGuard] },
    { path: 'resetpass', component: ResetpassComponent, canActivate: [NoAuthGuard] },
    { path: 'otp', component: OtpComponent, canActivate: [NoAuthGuard] },
    { path: 'home', component: PatienthomeComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'loginasmode', component: LoginasmodeComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'Demoportal', component: StykerLoginComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'clientSetup', component: ClientSetupComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'stykeruser/:id', component: ManageClientUserComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'deletepat', component: DelpatComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },

    { path: 'support', component: ResSupportComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'loginascn/:uname/:upass/:StrykerId', component: LoginascarenavicatorComponent, canActivate: [NoAuthGuard] },
    { path: 'loginfromonboard/:uname/:upass/:strkerId', component: LoginfromonboardComponent, canActivate: [NoAuthGuard] },
    { path: 'emailunsubscribe/:id', component: EmailunsubscribeComponent, canActivate: [NoAuthGuard] },
    { path: 'securityques', component: ProfilesecurityquestionComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'restpass', component: Restpass1Component, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard] },
    { path: 'securityquestion', component: SecurityquestionComponent, canActivate: [NoAuthGuard] },
    {
        path: 'care', component: HospitalComponent, canActivate: [AuthGuard],
        children: [
            {
                path: 'addpatient',
                component: AddpatientComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'addpatientnew',
                component: AddpatientComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'question',
                component: QuestionComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'addnewpatient',
                component: AddnewpatientComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },

            {
                path: 'toolkit',
                component: ToolkittComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'survey',
                component: PSAssementComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },



            {
                path: 'anybodypart',
                component: AnybodypartComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'appointments',
                component: AppointmentsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },

            {
                path: 'assessment/:name',
                component: AssementComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'patientlist',
                component: DashComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'patsummaryinfo/:patientId/:stage/:qualification',
                component: PatdashComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'patientqualification',
                component: PatqualifiComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]


            },
            {
                path: 'documepage1/:patId/:patSwfId/:surveyId/:surveyName/:status/:oldresultid',
                component: Documentpage1Component,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'reports',
                component: HospitalmetricsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'messages',
                component: MessagehospComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'mytodo',
                component: MytodoComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]
            },

            {
                path: 'newsymptom',
                component: NewsymptomComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'editsymptom/:patId/:patSwfId/:surveyId/:surveyName/:status/:patstatus/:todocategoryid/:survey/:careplansurveyid/:todoCpAssigned/:todoOverallCompleted/:ccreview',
                component: EditsymptomComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'pdfpage/:type/:id',
                component: PdfpageComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]
            },
            {
                path: 'postopppatient',
                component: PostoppComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'profile',
                component: ProfileComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'snfpatient',
                component: SnfpatientComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'surveymetrics/:mapid/:patid/:patientSWFId/:patientName/:productID',
                component: SurveymetricsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'patientsummary/:id',
                component: ViewsummaryComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'patientsummary/:dos/:status',
                component: ViewsummaryComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'patientsummary',
                component: ViewsummaryComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'patsummary/:patientId/:patientSWFId/:patientName',
                component: PatsummaryComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },

            {
                path: 'patientdetails',
                component: PatientdetailsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'patientdetail',
                component: PatientdetailsComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanDeactivateGuard]

            },
            {
                path: 'addpartner',
                component: AddpartnerComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'addgiver',//not in use
                component: AddgiverComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]

            },
            {
                path: 'cnmapping', //not in use
                component: CnmappingComponent,
                canActivate: [AuthGuard],
                canDeactivate: [CanSessionDeactivateGuard]
            }


        ]
    },
    {
        path: '', component: PatientComponent, canActivate: [AuthGuard],
        children: [
            {
                path: 'patient',
                component: FullLayoutComponent,
                canDeactivate: [CanSessionDeactivateGuard],
                children: [
                    {
                        path: 'activityboard',
                        component: ActivityBoardComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'contactme',
                        component: ContactmeComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'exercisevideos',
                        component: ExercisevideosComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'addcare',
                        component: AddcareComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'appointment',
                        component: AppointmentComponent,
                        canActivate: [AuthGuard]
                    },
                    {
                        path: 'uploadpage',
                        component: UploadpageComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'profilepage',
                        component: ProfilequesComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'viewsurvey/:name/:title',
                        component: PatientAssessmentDetailsComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'carefamily',
                        component: CarefamilyComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'dashboard',
                        component: DashboardComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'dashboard/:patswfid',
                        component: DashboardComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'dashboardnew',
                        component: DashboarddComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'messages',
                        component: MessageComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'myprofile',
                        component: MyprofileComponent

                    },
                    {
                        path: 'patsy',
                        component: PatsyComponent

                    },
                    {
                        path: 'surveys',
                        component: SurveysComponent,
                        canActivate: [AuthGuard]

                    },
                    // {
                    //     path: 'support',
                    //     component: SupportComponent,
                    //     canActivate: [AuthGuard]

                    // },
                    {
                        path: 'painlevel',
                        component: PainlevelComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'toolkit',
                        component: ToolkitComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'document',
                        component: DocumentComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'documents',
                        component: DocumentsComponent,
                        canActivate: [AuthGuard]

                    },
                    { path: 'need-help', component: NeedHelpComponent, canActivate: [AuthGuard] },
                ]

            }

        ]
    },
    {
        path: 'patient', component: PatientComponent, canActivate: [AuthGuard],canDeactivate: [CanSessionDeactivateGuard],
        children: [
                    {
                        path: 'assessment',
                        component: PAssementComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'helpdeskpage',
                        component: HelpdeskpageComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'postoperative/:type/:id',
                        component: PostoperativeComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'preventinginfection',
                        component: PreventinginfectionComponent,
                        canActivate: [AuthGuard]

                    },
                    {
                        path: 'surveys',
                        component: SurveysComponent,
                        canActivate: [AuthGuard]

                    }
        ]
    },
    // otherwise redirect to home
    { path: '**', redirectTo: '/login' }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, { useHash: true })
    ],
    exports: [
        RouterModule
    ],
    declarations: []
})

export class AppRoutingModule { }